import { render, staticRenderFns } from "./UponorLanding.vue?vue&type=template&id=eeddb536&scoped=true"
import script from "./UponorLanding.vue?vue&type=script&lang=js"
export * from "./UponorLanding.vue?vue&type=script&lang=js"
import style0 from "./UponorLanding.vue?vue&type=style&index=0&id=eeddb536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeddb536",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
